import React from "react";
import "./Frame11622.css";

function Frame11622(props) {
  const { children } = props;

  return (
    <div className="frame-115-88">
      <div className="decisional-model valign-text-middle inter-medium-star-dust-18px">{children}</div>
    </div>
  );
}

export default Frame11622;
